import type { Category } from "./types";

/** Base da API. O dataProvider aponta para `${API_URL}/admin`. */
export const API_URL: string =
  (import.meta.env.VITE_API_URL as string | undefined) ??
  "http://localhost:3000/v1";

export const ADMIN_API_URL = `${API_URL}/admin`;

/** Chave do access token JWT em localStorage (apenas o admin; web usa cookie). */
export const TOKEN_KEY = "mel-admin-access-token";
export const USER_KEY = "mel-admin-user";

/** Rótulos pt-BR das 5 categorias (colhido de references/src/lib/categories.ts). */
export const CATEGORY_LABELS: Record<Category, string> = {
  lembrete: "Lembrete",
  evento: "Evento",
  saude: "Saúde",
  tarefa: "Tarefa",
  nota: "Nota",
};

/** Preços de referência (colhido de references/src/lib/plans.ts). */
export const MONTHLY_PRICE_BRL = 19.9;
export const ANNUAL_PRICE_BRL = 199.0;

/** Limites freemium (referência: 30/mês free). Reconfirmar com a API. */
export const FREE_LIMIT = 30;
export const PREMIUM_LIMIT = 1000;
